export const EUR_CHF_FALLBACK_RATE = 0.9222

export const EUR_CHF_HISTORY = {
    '2025-13-11': 0.9222,
    '2025-12-11': 0.925,
    '2025-11-11': 0.9273,
    '2025-10-11': 0.9306,
    '2025-07-11': 0.9313,
    '2025-06-11': 0.9313,
    '2025-05-11': 0.9313,
    '2025-04-11': 0.9306,
    '2025-03-11': 0.9309,
    '2025-31-10': 0.9281,
    '2025-30-10': 0.9275,
    '2025-29-10': 0.9281,
    '2025-28-10': 0.9245,
    '2025-27-10': 0.9264,
    '2025-24-10': 0.9251,
    '2025-23-10': 0.9239,
    '2025-22-10': 0.9242,
    '2025-21-10': 0.9237,
    '2025-20-10': 0.9227,
    '2025-17-10': 0.924,
    '2025-16-10': 0.9268,
    '2025-15-10': 0.9278,
    '2025-14-10': 0.9298,
    '2025-13-10': 0.9304,
    '2025-10-10': 0.9287,
    '2025-09-10': 0.9325,
    '2025-08-10': 0.9325,
    '2025-07-10': 0.9306,
    '2025-06-10': 0.9311,
    '2025-03-10': 0.934,
    '2025-02-10': 0.9349,
    '2025-01-10': 0.9349,
    '2025-30-09': 0.9345,
    '2025-29-09': 0.9353,
    '2025-26-09': 0.9336,
    '2025-25-09': 0.9329,
    '2025-24-09': 0.9335,
    '2025-23-09': 0.9349,
    '2025-22-09': 0.9354,
    '2025-19-09': 0.9344,
    '2025-18-09': 0.9341,
    '2025-17-09': 0.932,
    '2025-16-09': 0.9327,
    '2025-15-09': 0.9347,
    '2025-12-09': 0.9348,
    '2025-11-09': 0.9338,
    '2025-10-09': 0.9347,
    '2025-09-09': 0.9338,
    '2025-08-09': 0.9332,
    '2025-05-09': 0.9354,
    '2025-04-09': 0.9385,
    '2025-03-09': 0.9375,
    '2025-02-09': 0.9365,
    '2025-01-09': 0.9376,
    '2025-29-08': 0.9356,
    '2025-28-08': 0.9365,
    '2025-27-08': 0.9338,
    '2025-26-08': 0.9352,
    '2025-25-08': 0.9365,
    '2025-22-08': 0.9391,
    '2025-21-08': 0.9388,
    '2025-20-08': 0.9369,
    '2025-19-08': 0.9409,
    '2025-18-08': 0.9417,
    '2025-15-08': 0.9434,
    '2025-14-08': 0.9407,
    '2025-13-08': 0.9426,
    '2025-12-08': 0.9416,
    '2025-11-08': 0.9438,
    '2025-08-08': 0.9407,
    '2025-07-08': 0.941,
    '2025-06-08': 0.9405,
    '2025-05-08': 0.9351,
    '2025-04-08': 0.9353,
    '2025-01-08': 0.9315,
    '2025-31-07': 0.9274,
    '2025-30-07': 0.9293,
    '2025-29-07': 0.9306,
    '2025-28-07': 0.9313,
    '2025-25-07': 0.9333,
    '2025-24-07': 0.9347,
    '2025-23-07': 0.9328,
    '2025-22-07': 0.9314,
    '2025-21-07': 0.9333,
    '2025-18-07': 0.9318,
    '2025-17-07': 0.933,
    '2025-16-07': 0.9314,
    '2025-15-07': 0.93,
    '2025-14-07': 0.9307,
    '2025-11-07': 0.9312,
    '2025-10-07': 0.9327,
    '2025-09-07': 0.931,
    '2025-08-07': 0.9333,
    '2025-07-07': 0.9351,
    '2025-04-07': 0.9354,
    '2025-03-07': 0.9347,
    '2025-02-07': 0.9345,
    '2025-01-07': 0.934,
    '2025-30-06': 0.9348,
    '2025-27-06': 0.9365,
    '2025-26-06': 0.9364,
    '2025-25-06': 0.9384,
    '2025-24-06': 0.9351,
    '2025-23-06': 0.9409,
    '2025-20-06': 0.942,
    '2025-19-06': 0.9388,
    '2025-18-06': 0.9401,
    '2025-17-06': 0.9373,
    '2025-16-06': 0.9413,
    '2025-13-06': 0.9372,
    '2025-12-06': 0.9387,
    '2025-11-06': 0.9423,
    '2025-10-06': 0.9399,
    '2025-09-06': 0.9388,
    '2025-06-06': 0.9363,
    '2025-05-06': 0.9383,
    '2025-04-06': 0.9344,
    '2025-03-06': 0.9368,
    '2025-02-06': 0.935,
    '2025-30-05': 0.9335,
    '2025-29-05': 0.9359,
    '2025-28-05': 0.9345,
    '2025-27-05': 0.9371,
    '2025-26-05': 0.9351,
    '2025-23-05': 0.9335,
    '2025-22-05': 0.9353,
    '2025-21-05': 0.9353,
    '2025-20-05': 0.9347,
    '2025-19-05': 0.9384,
    '2025-16-05': 0.9353,
    '2025-15-05': 0.9353,
    '2025-14-05': 0.9411,
    '2025-13-05': 0.939,
    '2025-12-05': 0.9376,
    '2025-09-05': 0.9352,
    '2025-08-05': 0.9344,
    '2025-07-05': 0.9312,
    '2025-06-05': 0.9348,
    '2025-05-05': 0.9304,
    '2025-02-05': 0.9339,
    '2025-01-05': 0.9367,
    '2025-30-04': 0.936,
    '2025-29-04': 0.938,
    '2025-28-04': 0.9366,
    '2025-25-04': 0.9409,
    '2025-24-04': 0.9422,
    '2025-23-04': 0.9403,
    '2025-22-04': 0.9354,
    '2025-21-04': 0.9312,
    '2025-18-04': 0.9297,
    '2025-17-04': 0.9314,
    '2025-16-04': 0.9265,
    '2025-15-04': 0.9287,
    '2025-14-04': 0.9244,
    '2025-11-04': 0.926,
    '2025-10-04': 0.9218,
    '2025-09-04': 0.9397,
    '2025-08-04': 0.9284,
    '2025-07-04': 0.9374,
    '2025-04-04': 0.9427,
    '2025-03-04': 0.9493,
    '2025-02-04': 0.9568,
    '2025-01-04': 0.9536,
    '2025-31-03': 0.9563,
    '2025-28-03': 0.9531,
    '2025-27-03': 0.9519,
    '2025-26-03': 0.9499,
    '2025-25-03': 0.9523,
    '2025-24-03': 0.9535,
    '2025-21-03': 0.955,
    '2025-20-03': 0.9564,
    '2025-19-03': 0.9562,
    '2025-18-03': 0.959,
    '2025-17-03': 0.9619,
    '2025-14-03': 0.9629,
    '2025-13-03': 0.957,
    '2025-12-03': 0.9599,
    '2025-11-03': 0.9635,
    '2025-10-03': 0.9541,
    '2025-07-03': 0.9527,
    '2025-06-03': 0.9531,
    '2025-05-03': 0.9608,
    '2025-04-03': 0.9451,
    '2025-03-03': 0.9403,
    '2025-28-02': 0.9371,
    '2025-27-02': 0.9353,
    '2025-26-02': 0.9379,
    '2025-25-02': 0.9387,
    '2025-24-02': 0.9386,
    '2025-21-02': 0.9388,
    '2025-20-02': 0.9425,
    '2025-19-02': 0.9424,
    '2025-18-02': 0.9432,
    '2025-17-02': 0.9441,
    '2025-14-02': 0.9432,
    '2025-13-02': 0.9446,
    '2025-12-02': 0.9485,
    '2025-11-02': 0.9458,
    '2025-10-02': 0.9389,
    '2025-07-02': 0.9391,
    '2025-06-02': 0.9393,
    '2025-05-02': 0.9379,
    '2025-04-02': 0.939,
    '2025-03-02': 0.9414,
    '2025-31-01': 0.9437,
    '2025-30-01': 0.9448,
    '2025-29-01': 0.9446,
    '2025-28-01': 0.9425,
    '2025-27-01': 0.9462,
    '2025-24-01': 0.9504,
    '2025-23-01': 0.9446,
    '2025-22-01': 0.9434,
    '2025-21-01': 0.9447,
    '2025-20-01': 0.9437,
    '2025-17-01': 0.9397,
    '2025-16-01': 0.9376,
    '2025-15-01': 0.939,
    '2025-14-01': 0.94,
    '2025-13-01': 0.9389,
    '2025-10-01': 0.9388,
    '2025-09-01': 0.9391,
    '2025-08-01': 0.9398,
    '2025-07-01': 0.9403,
    '2025-06-01': 0.9399,
    '2025-03-01': 0.9364,
    '2025-02-01': 0.9361,
    '2025-01-01': 0.9393,
    '2024-31-12': 0.9392,
    '2024-30-12': 0.9405,
    '2024-27-12': 0.9402,
    '2024-26-12': 0.9366,
    '2024-25-12': 0.9352,
    '2024-24-12': 0.936,
    '2024-23-12': 0.9349,
    '2024-20-12': 0.9313,
    '2024-19-12': 0.9311,
    '2024-18-12': 0.9324,
    '2024-17-12': 0.9364,
    '2024-16-12': 0.9396,
    '2024-13-12': 0.9374,
    '2024-12-12': 0.9337,
    '2024-11-12': 0.9278,
    '2024-10-12': 0.9289,
    '2024-09-12': 0.9271,
    '2024-06-12': 0.9283,
    '2024-05-12': 0.93,
    '2024-04-12': 0.9292,
    '2024-03-12': 0.9314,
    '2024-02-12': 0.9308,
    '2024-29-11': 0.9316,
    '2024-28-11': 0.9315,
    '2024-27-11': 0.9314,
    '2024-26-11': 0.9295,
    '2024-25-11': 0.9297,
    '2024-22-11': 0.9312,
    '2024-21-11': 0.9284,
    '2024-20-11': 0.9319,
    '2024-19-11': 0.9346,
    '2024-18-11': 0.9357,
    '2024-15-11': 0.936,
    '2024-14-11': 0.9373,
    '2024-13-11': 0.9358,
    '2024-12-11': 0.9364,
    '2024-11-11': 0.9381,
    '2024-08-11': 0.9381,
    '2024-07-11': 0.9426,
    '2024-06-11': 0.9401,
    '2024-05-11': 0.9433,
    '2024-04-11': 0.9398,
    '2024-01-11': 0.9424,
    '2024-31-10': 0.9399,
    '2024-30-10': 0.9408,
    '2024-29-10': 0.9379,
    '2024-28-10': 0.9355,
    '2024-25-10': 0.9352,
    '2024-24-10': 0.9372,
    '2024-23-10': 0.934,
    '2024-22-10': 0.9343,
    '2024-21-10': 0.9367,
    '2024-18-10': 0.9396,
    '2024-17-10': 0.9377,
    '2024-16-10': 0.9399,
    '2024-15-10': 0.9383,
    '2024-14-10': 0.9409,
    '2024-11-10': 0.9373,
    '2024-10-10': 0.9361,
    '2024-09-10': 0.9413,
    '2024-08-10': 0.9408,
    '2024-07-10': 0.9378,
    '2024-04-10': 0.9417,
    '2024-03-10': 0.9407,
    '2024-02-10': 0.9385,
    '2024-01-10': 0.9369,
    '2024-30-09': 0.9414,
    '2024-27-09': 0.9383,
    '2024-26-09': 0.9456,
    '2024-25-09': 0.9467,
    '2024-24-09': 0.9428,
    '2024-23-09': 0.9417,
    '2024-20-09': 0.9489,
    '2024-19-09': 0.9461,
    '2024-18-09': 0.9408,
    '2024-17-09': 0.9414,
    '2024-16-09': 0.9403,
    '2024-13-09': 0.9402,
    '2024-12-09': 0.9424,
    '2024-11-09': 0.9384,
    '2024-10-09': 0.9332,
    '2024-09-09': 0.9371,
    '2024-06-09': 0.9341,
    '2024-05-09': 0.9377,
    '2024-04-09': 0.938,
    '2024-03-09': 0.939,
    '2024-02-09': 0.9427,
    '2024-30-08': 0.9388,
    '2024-29-08': 0.9384,
    '2024-28-08': 0.9365,
    '2024-27-08': 0.9411,
    '2024-26-08': 0.9456,
    '2024-23-08': 0.9488,
    '2024-22-08': 0.947,
    '2024-21-08': 0.9492,
    '2024-20-08': 0.9505,
    '2024-19-08': 0.9563,
    '2024-16-08': 0.955,
    '2024-15-08': 0.9572,
    '2024-14-08': 0.9526,
    '2024-13-08': 0.9504,
    '2024-12-08': 0.9456,
    '2024-09-08': 0.9445,
    '2024-08-08': 0.9459,
    '2024-07-08': 0.941,
    '2024-06-08': 0.9306,
    '2024-05-08': 0.9334,
    '2024-02-08': 0.9355,
    '2024-01-08': 0.9418,
    '2024-31-07': 0.9503,
    '2024-30-07': 0.9544,
    '2024-29-07': 0.9585,
    '2024-26-07': 0.9592,
    '2024-25-07': 0.9559,
    '2024-24-07': 0.9591,
    '2024-23-07': 0.9668,
    '2024-22-07': 0.9688,
    '2024-19-07': 0.967,
    '2024-18-07': 0.9668,
    '2024-17-07': 0.966,
    '2024-16-07': 0.9735,
    '2024-15-07': 0.9757,
    '2024-12-07': 0.9752,
    '2024-11-07': 0.9741,
    '2024-10-07': 0.9741,
    '2024-09-07': 0.9706,
    '2024-08-07': 0.9713,
    '2024-05-07': 0.9709,
    '2024-04-07': 0.9729,
    '2024-03-07': 0.9722,
    '2024-02-07': 0.9709,
    '2024-01-07': 0.9694,
    '2024-28-06': 0.9628,
    '2024-27-06': 0.9616,
    '2024-26-06': 0.9581,
    '2024-25-06': 0.9584,
    '2024-24-06': 0.958,
    '2024-21-06': 0.9555,
    '2024-20-06': 0.9535,
    '2024-19-06': 0.9499,
    '2024-18-06': 0.9493,
    '2024-17-06': 0.9546,
    '2024-14-06': 0.9524,
    '2024-13-06': 0.9594,
    '2024-12-06': 0.9663,
    '2024-11-06': 0.9637,
    '2024-10-06': 0.9647,
    '2024-07-06': 0.9676,
    '2024-06-06': 0.9681,
    '2024-05-06': 0.9707,
    '2024-04-06': 0.9678,
    '2024-03-06': 0.9763,
    '2024-31-05': 0.9777,
    '2024-30-05': 0.9781,
    '2024-29-05': 0.986,
    '2024-28-05': 0.9902,
    '2024-27-05': 0.9921,
    '2024-24-05': 0.9919,
    '2024-23-05': 0.9886,
    '2024-22-05': 0.9908,
    '2024-21-05': 0.9884,
    '2024-20-05': 0.9882,
    '2024-17-05': 0.988,
    '2024-16-05': 0.9844,
    '2024-15-05': 0.9816,
    '2024-14-05': 0.9805,
    '2024-13-05': 0.9797,
    '2024-10-05': 0.976,
    '2024-09-05': 0.9765,
    '2024-08-05': 0.9757,
    '2024-07-05': 0.9766,
    '2024-06-05': 0.9757,
    '2024-03-05': 0.974,
    '2024-02-05': 0.9765,
    '2024-01-05': 0.9804,
    '2024-30-04': 0.9802,
    '2024-29-04': 0.9758,
    '2024-26-04': 0.9772,
    '2024-25-04': 0.9785,
    '2024-24-04': 0.9787,
    '2024-23-04': 0.9754,
    '2024-22-04': 0.9712,
    '2024-19-04': 0.9695,
    '2024-18-04': 0.9707,
    '2024-17-04': 0.9717,
    '2024-16-04': 0.969,
    '2024-15-04': 0.9681,
    '2024-12-04': 0.9727,
    '2024-11-04': 0.9757,
    '2024-10-04': 0.9802,
    '2024-09-04': 0.9807,
    '2024-08-04': 0.9828,
    '2024-05-04': 0.9767,
    '2024-04-04': 0.9766,
    '2024-03-04': 0.9783,
    '2024-02-04': 0.9775,
    '2024-01-04': 0.9713,
    '2024-29-03': 0.9732,
    '2024-28-03': 0.9726,
    '2024-27-03': 0.9783,
    '2024-26-03': 0.9788,
    '2024-25-03': 0.9744,
    '2024-22-03': 0.9699,
    '2024-21-03': 0.9747,
    '2024-20-03': 0.9685,
    '2024-19-03': 0.9647,
    '2024-18-03': 0.965,
    '2024-15-03': 0.9619,
    '2024-14-03': 0.9617,
    '2024-13-03': 0.9617,
    '2024-12-03': 0.9583,
    '2024-11-03': 0.9585,
    '2024-08-03': 0.9597,
    '2024-07-03': 0.9605,
    '2024-06-03': 0.961,
    '2024-05-03': 0.9587,
    '2024-04-03': 0.9603,
    '2024-01-03': 0.9572,
    '2024-29-02': 0.9554,
    '2024-28-02': 0.9521,
    '2024-27-02': 0.9524,
    '2024-26-02': 0.9546,
    '2024-23-02': 0.9533,
    '2024-22-02': 0.9525,
    '2024-21-02': 0.9512,
    '2024-20-02': 0.9526,
    '2024-19-02': 0.9506,
    '2024-16-02': 0.9487,
    '2024-15-02': 0.9477,
    '2024-14-02': 0.9502,
    '2024-13-02': 0.9496,
    '2024-12-02': 0.9431,
    '2024-09-02': 0.943,
    '2024-08-02': 0.9414,
    '2024-07-02': 0.9417,
    '2024-06-02': 0.9352,
    '2024-05-02': 0.935,
    '2024-02-02': 0.9343,
    '2024-01-02': 0.9323,
    '2024-31-01': 0.9314,
    '2024-30-01': 0.9343,
    '2024-29-01': 0.9328,
    '2024-26-01': 0.938,
    '2024-25-01': 0.94,
    '2024-24-01': 0.9388,
    '2024-23-01': 0.9439,
    '2024-22-01': 0.9455,
    '2024-19-01': 0.9464,
    '2024-18-01': 0.9439,
    '2024-17-01': 0.9403,
    '2024-16-01': 0.9368,
    '2024-15-01': 0.9365,
    '2024-12-01': 0.9331,
    '2024-11-01': 0.9344,
    '2024-10-01': 0.9334,
    '2024-09-01': 0.9313,
    '2024-08-01': 0.9283,
    '2024-05-01': 0.9298,
    '2024-04-01': 0.9302,
    '2024-03-01': 0.9272,
    '2024-02-01': 0.9298,
    '2024-01-01': 0.929,
    '2023-29-12': 0.9287,
    '2023-28-12': 0.9338,
    '2023-27-12': 0.9361,
    '2023-26-12': 0.9423,
    '2023-25-12': 0.9424,
    '2023-22-12': 0.9419,
    '2023-21-12': 0.9424,
    '2023-20-12': 0.9435,
    '2023-19-12': 0.9452,
    '2023-18-12': 0.9469,
    '2023-15-12': 0.948,
    '2023-14-12': 0.9534,
    '2023-13-12': 0.9476,
    '2023-12-12': 0.9444,
    '2023-11-12': 0.9453,
    '2023-08-12': 0.9465,
    '2023-07-12': 0.9443,
    '2023-06-12': 0.9412,
    '2023-05-12': 0.9443,
    '2023-04-12': 0.9455,
    '2023-01-12': 0.9458,
    '2023-30-11': 0.9525,
    '2023-29-11': 0.9585,
    '2023-28-11': 0.9649,
    '2023-27-11': 0.9641,
    '2023-24-11': 0.9653,
    '2023-23-11': 0.9641,
    '2023-22-11': 0.9621,
    '2023-21-11': 0.9637,
    '2023-20-11': 0.9678,
    '2023-17-11': 0.9658,
    '2023-16-11': 0.964,
    '2023-15-11': 0.963,
    '2023-14-11': 0.9671,
    '2023-13-11': 0.9642,
    '2023-10-11': 0.9642,
    '2023-09-11': 0.9628,
    '2023-08-11': 0.9627,
    '2023-07-11': 0.9629,
    '2023-06-11': 0.9638,
    '2023-03-11': 0.9643,
    '2023-02-11': 0.9623,
    '2023-01-11': 0.9593,
    '2023-31-10': 0.9628,
    '2023-30-10': 0.9571,
    '2023-27-10': 0.9529,
    '2023-26-10': 0.9489,
    '2023-25-10': 0.9472,
    '2023-24-10': 0.9457,
    '2023-23-10': 0.9503,
    '2023-20-10': 0.9446,
    '2023-19-10': 0.943,
    '2023-18-10': 0.947,
    '2023-17-10': 0.9519,
    '2023-16-10': 0.9502,
    '2023-13-10': 0.9479,
    '2023-12-10': 0.956,
    '2023-11-10': 0.9574,
    '2023-10-10': 0.9588,
    '2023-09-10': 0.9577,
    '2023-06-10': 0.9632,
    '2023-05-10': 0.9621,
    '2023-04-10': 0.9631,
    '2023-03-10': 0.9636,
    '2023-02-10': 0.9618,
    '2023-29-09': 0.967,
    '2023-28-09': 0.9659,
    '2023-27-09': 0.9672,
    '2023-26-09': 0.9678,
    '2023-25-09': 0.9657,
    '2023-22-09': 0.966,
    '2023-21-09': 0.9638,
    '2023-20-09': 0.9576,
    '2023-19-09': 0.9583,
    '2023-18-09': 0.9588,
    '2023-15-09': 0.9562,
    '2023-14-09': 0.9529,
    '2023-13-09': 0.9587,
    '2023-12-09': 0.9582,
    '2023-11-09': 0.9573,
    '2023-08-09': 0.9556,
    '2023-07-09': 0.9551,
    '2023-06-09': 0.9557,
    '2023-05-09': 0.9536,
    '2023-04-09': 0.954,
    '2023-01-09': 0.9541,
    '2023-31-08': 0.9574,
    '2023-30-08': 0.959,
    '2023-29-08': 0.9552,
    '2023-28-08': 0.9558,
    '2023-25-08': 0.9553,
    '2023-24-08': 0.9558,
    '2023-23-08': 0.9531,
    '2023-22-08': 0.9544,
    '2023-21-08': 0.9566,
    '2023-18-08': 0.9579,
    '2023-17-08': 0.9547,
    '2023-16-08': 0.9571,
    '2023-15-08': 0.9574,
    '2023-14-08': 0.9574,
    '2023-11-08': 0.9595,
    '2023-10-08': 0.9624,
    '2023-09-08': 0.9624,
    '2023-08-08': 0.9596,
    '2023-07-08': 0.9598,
    '2023-04-08': 0.9608,
    '2023-03-08': 0.9566,
    '2023-02-08': 0.9596,
    '2023-01-08': 0.9611,
    '2023-31-07': 0.9585,
    '2023-28-07': 0.9581,
    '2023-27-07': 0.9532,
    '2023-26-07': 0.9538,
    '2023-25-07': 0.9543,
    '2023-24-07': 0.9621,
    '2023-21-07': 0.9627,
    '2023-20-07': 0.9645,
    '2023-19-07': 0.9612,
    '2023-18-07': 0.9623,
    '2023-17-07': 0.9668,
    '2023-14-07': 0.9674,
    '2023-13-07': 0.9637,
    '2023-12-07': 0.9652,
    '2023-11-07': 0.9678,
    '2023-10-07': 0.9735,
    '2023-07-07': 0.9741,
    '2023-06-07': 0.9744,
    '2023-05-07': 0.9753,
    '2023-04-07': 0.9753,
    '2023-03-07': 0.978,
    '2023-30-06': 0.9768,
    '2023-29-06': 0.977,
    '2023-28-06': 0.9785,
    '2023-27-06': 0.9793,
    '2023-26-06': 0.9766,
    '2023-23-06': 0.9771,
    '2023-22-06': 0.9803,
    '2023-21-06': 0.9809,
    '2023-20-06': 0.9801,
    '2023-19-06': 0.978,
    '2023-16-06': 0.9774,
    '2023-15-06': 0.9759,
    '2023-14-06': 0.9759,
    '2023-13-06': 0.9766,
    '2023-12-06': 0.9778,
    '2023-09-06': 0.9713,
    '2023-08-06': 0.9686,
    '2023-07-06': 0.9737,
    '2023-06-06': 0.9704,
    '2023-05-06': 0.9706,
    '2023-02-06': 0.9731,
    '2023-01-06': 0.9742,
    '2023-31-05': 0.9731,
    '2023-30-05': 0.9722,
    '2023-29-05': 0.9678,
    '2023-26-05': 0.9708,
    '2023-25-05': 0.9706,
    '2023-24-05': 0.9727,
    '2023-23-05': 0.9703,
    '2023-22-05': 0.9705,
    '2023-19-05': 0.9717,
    '2023-18-05': 0.975,
    '2023-17-05': 0.9741,
    '2023-16-05': 0.9735,
    '2023-15-05': 0.9737,
    '2023-12-05': 0.9742,
    '2023-11-05': 0.9757,
    '2023-10-05': 0.9768,
    '2023-09-05': 0.9758,
    '2023-08-05': 0.9785,
    '2023-05-05': 0.9814,
    '2023-04-05': 0.9751,
    '2023-03-05': 0.9773,
    '2023-02-05': 0.9823,
    '2023-01-05': 0.983,
    '2023-28-04': 0.9853,
    '2023-27-04': 0.9859,
    '2023-26-04': 0.9838,
    '2023-25-04': 0.9784,
    '2023-24-04': 0.9797,
    '2023-21-04': 0.9807,
    '2023-20-04': 0.9784,
    '2023-19-04': 0.983,
    '2023-18-04': 0.9832,
    '2023-17-04': 0.9817,
    '2023-14-04': 0.9831,
    '2023-13-04': 0.982,
    '2023-12-04': 0.9845,
    '2023-11-04': 0.9855,
    '2023-10-04': 0.9875,
    '2023-07-04': 0.9863,
    '2023-06-04': 0.9874,
    '2023-05-04': 0.989,
    '2023-04-04': 0.9918,
    '2023-03-04': 0.994,
    '2023-31-03': 0.9916,
    '2023-30-03': 0.9954,
    '2023-29-03': 0.9958,
    '2023-28-03': 0.9978,
    '2023-27-03': 0.9886,
    '2023-24-03': 0.9897,
    '2023-23-03': 0.9925,
    '2023-22-03': 0.9957,
    '2023-21-03': 0.9929,
    '2023-20-03': 0.9956,
    '2023-17-03': 0.9875,
    '2023-16-03': 0.9853,
    '2023-15-03': 0.9866,
    '2023-14-03': 0.9809,
    '2023-13-03': 0.9781,
    '2023-10-03': 0.9804,
    '2023-09-03': 0.9865,
    '2023-08-03': 0.9928,
    '2023-07-03': 0.9929,
    '2023-06-03': 0.9938,
    '2023-03-03': 0.9949,
    '2023-02-03': 0.9984,
    '2023-01-03': 1.0021,
    '2023-28-02': 0.9964,
    '2023-27-02': 0.9927,
    '2023-24-02': 0.9922,
    '2023-23-02': 0.9894,
    '2023-22-02': 0.9872,
    '2023-21-02': 0.9876,
    '2023-20-02': 0.9864,
    '2023-17-02': 0.9887,
    '2023-16-02': 0.987,
    '2023-15-02': 0.9872,
    '2023-14-02': 0.9888,
    '2023-13-02': 0.9855,
    '2023-10-02': 0.9862,
    '2023-09-02': 0.9901,
    '2023-08-02': 0.9861,
    '2023-07-02': 0.9888,
    '2023-06-02': 0.996,
    '2023-03-02': 0.9992,
    '2023-02-02': 0.996,
    '2023-01-02': 0.998,
    '2023-31-01': 0.9951,
    '2023-30-01': 1.0029,
    '2023-27-01': 1.0005,
    '2023-26-01': 1.002,
    '2023-25-01': 1.0017,
    '2023-24-01': 1.003,
    '2023-23-01': 1.0017,
    '2023-20-01': 0.999,
    '2023-19-01': 0.992,
    '2023-18-01': 0.9885,
    '2023-17-01': 0.9945,
    '2023-16-01': 1.0021,
    '2023-13-01': 1.0032,
    '2023-12-01': 1.0064,
    '2023-11-01': 1.0012,
    '2023-10-01': 0.99,
    '2023-09-01': 0.9884,
    '2023-06-01': 0.987,
    '2023-05-01': 0.9848,
    '2023-04-01': 0.9851,
    '2023-03-01': 0.9874,
    '2023-02-01': 0.9862,
    '2022-30-12': 0.9893,
    '2022-29-12': 0.984,
    '2022-28-12': 0.9854,
    '2022-27-12': 0.9881,
    '2022-26-12': 0.991,
    '2022-23-12': 0.9906,
    '2022-22-12': 0.9862,
    '2022-21-12': 0.9825,
    '2022-20-12': 0.9835,
    '2022-19-12': 0.9846,
    '2022-16-12': 0.9878,
    '2022-15-12': 0.9862,
    '2022-14-12': 0.9874,
    '2022-13-12': 0.9873,
    '2022-12-12': 0.9861,
    '2022-09-12': 0.9838,
    '2022-08-12': 0.9885,
    '2022-07-12': 0.9881,
    '2022-06-12': 0.9858,
    '2022-05-12': 0.9886,
    '2022-02-12': 0.9871,
    '2022-01-12': 0.9859,
    '2022-30-11': 0.984,
    '2022-29-11': 0.985,
    '2022-28-11': 0.9811,
    '2022-25-11': 0.9826,
    '2022-24-11': 0.9816,
    '2022-23-11': 0.9797,
    '2022-22-11': 0.9805,
    '2022-21-11': 0.9821,
    '2022-18-11': 0.9855,
    '2022-17-11': 0.9858,
    '2022-16-11': 0.9813,
    '2022-15-11': 0.9769,
    '2022-14-11': 0.9735,
    '2022-11-11': 0.9748,
    '2022-10-11': 0.9836,
    '2022-09-11': 0.9852,
    '2022-08-11': 0.9928,
    '2022-07-11': 0.9899,
    '2022-04-11': 0.9898,
    '2022-03-11': 0.9878,
    '2022-02-11': 0.9844,
    '2022-01-11': 0.9871,
    '2022-31-10': 0.9894,
    '2022-28-10': 0.9924,
    '2022-27-10': 0.9868,
    '2022-26-10': 0.9941,
    '2022-25-10': 0.9912,
    '2022-24-10': 0.9876,
    '2022-21-10': 0.9836,
    '2022-20-10': 0.9816,
    '2022-19-10': 0.9811,
    '2022-18-10': 0.9797,
    '2022-17-10': 0.9802,
    '2022-14-10': 0.9769,
    '2022-13-10': 0.978,
    '2022-12-10': 0.9678,
    '2022-11-10': 0.9672,
    '2022-10-10': 0.9697,
    '2022-07-10': 0.9685,
    '2022-06-10': 0.9697,
    '2022-05-10': 0.972,
    '2022-04-10': 0.9774,
    '2022-03-10': 0.9742,
    '2022-30-09': 0.967,
    '2022-29-09': 0.9575,
    '2022-28-09': 0.9501,
    '2022-27-09': 0.9509,
    '2022-26-09': 0.9542,
    '2022-23-09': 0.9515,
    '2022-22-09': 0.9603,
    '2022-21-09': 0.9501,
    '2022-20-09': 0.9611,
    '2022-19-09': 0.9663,
    '2022-16-09': 0.966,
    '2022-15-09': 0.9616,
    '2022-14-09': 0.9601,
    '2022-13-09': 0.9582,
    '2022-12-09': 0.9647,
    '2022-09-09': 0.9636,
    '2022-08-09': 0.9704,
    '2022-07-09': 0.9767,
    '2022-06-09': 0.9748,
    '2022-05-09': 0.9724,
    '2022-02-09': 0.9756,
    '2022-01-09': 0.9765,
    '2022-31-08': 0.983,
    '2022-30-08': 0.9751,
    '2022-29-08': 0.9676,
    '2022-26-08': 0.9625,
    '2022-25-08': 0.9611,
    '2022-24-08': 0.963,
    '2022-23-08': 0.9606,
    '2022-22-08': 0.9587,
    '2022-19-08': 0.9622,
    '2022-18-08': 0.9652,
    '2022-17-08': 0.9687,
    '2022-16-08': 0.9654,
    '2022-15-08': 0.9614,
    '2022-12-08': 0.9656,
    '2022-11-08': 0.9705,
    '2022-10-08': 0.9703,
    '2022-09-08': 0.9736,
    '2022-08-08': 0.9736,
    '2022-05-08': 0.9785,
    '2022-04-08': 0.9785,
    '2022-03-08': 0.9762,
    '2022-02-08': 0.9731,
    '2022-01-08': 0.9743,
    '2022-29-07': 0.9721,
    '2022-28-07': 0.9733,
    '2022-27-07': 0.9791,
    '2022-26-07': 0.9736,
    '2022-25-07': 0.9856,
    '2022-22-07': 0.9815,
    '2022-21-07': 0.9885,
    '2022-20-07': 0.9885,
    '2022-19-07': 0.9902,
    '2022-18-07': 0.9912,
    '2022-15-07': 0.9846,
    '2022-14-07': 0.9854,
    '2022-13-07': 0.9846,
    '2022-12-07': 0.9852,
    '2022-11-07': 0.9867,
    '2022-08-07': 0.9941,
    '2022-07-07': 0.9892,
    '2022-06-07': 0.988,
    '2022-05-07': 0.9941,
    '2022-04-07': 1.0014,
    '2022-01-07': 1.0004,
    '2022-30-06': 1.0009,
    '2022-29-06': 0.9971,
    '2022-28-06': 1.0067,
    '2022-27-06': 1.0115,
    '2022-24-06': 1.0109,
    '2022-23-06': 1.0115,
    '2022-22-06': 1.0157,
    '2022-21-06': 1.0166,
    '2022-20-06': 1.0165,
    '2022-17-06': 1.0185,
    '2022-16-06': 1.0196,
    '2022-15-06': 1.038,
    '2022-14-06': 1.0429,
    '2022-13-06': 1.0381,
    '2022-10-06': 1.0379,
    '2022-09-06': 1.0406,
    '2022-08-06': 1.0478,
    '2022-07-06': 1.041,
    '2022-06-06': 1.0377,
    '2022-03-06': 1.0316,
    '2022-02-06': 1.0296,
    '2022-01-06': 1.0258,
    '2022-31-05': 1.0295,
    '2022-30-05': 1.0317,
    '2022-27-05': 1.0266,
    '2022-26-05': 1.0288,
    '2022-25-05': 1.0269,
    '2022-24-05': 1.0307,
    '2022-23-05': 1.0322,
    '2022-20-05': 1.0296,
    '2022-19-05': 1.0301,
    '2022-18-05': 1.0337,
    '2022-17-05': 1.0477,
    '2022-16-05': 1.045,
    '2022-13-05': 1.0429,
    '2022-12-05': 1.0409,
    '2022-11-05': 1.0451,
    '2022-10-05': 1.0485,
    '2022-09-05': 1.0487,
    '2022-06-05': 1.0432,
    '2022-05-05': 1.038,
    '2022-04-05': 1.0324,
    '2022-03-05': 1.0297,
    '2022-02-05': 1.027,
    '2022-29-04': 1.0261,
    '2022-28-04': 1.0205,
    '2022-27-04': 1.0227,
    '2022-26-04': 1.0234,
    '2022-25-04': 1.0277,
    '2022-22-04': 1.0331,
    '2022-21-04': 1.0325,
    '2022-20-04': 1.0289,
    '2022-19-04': 1.0264,
    '2022-18-04': 1.0184,
    '2022-15-04': 1.0185,
    '2022-14-04': 1.0202,
    '2022-13-04': 1.0172,
    '2022-12-04': 1.0102,
    '2022-11-04': 1.0131,
    '2022-08-04': 1.0165,
    '2022-07-04': 1.016,
    '2022-06-04': 1.0165,
    '2022-05-04': 1.0138,
    '2022-04-04': 1.016,
    '2022-01-04': 1.0228,
    '2022-31-03': 1.0209,
    '2022-30-03': 1.03,
    '2022-29-03': 1.0323,
    '2022-28-03': 1.0251,
    '2022-25-03': 1.0216,
    '2022-24-03': 1.0225,
    '2022-23-03': 1.0239,
    '2022-22-03': 1.0284,
    '2022-21-03': 1.0282,
    '2022-18-03': 1.0293,
    '2022-17-03': 1.0388,
    '2022-16-03': 1.0372,
    '2022-15-03': 1.0305,
    '2022-14-03': 1.0266,
    '2022-11-03': 1.0196,
    '2022-10-03': 1.0214,
    '2022-09-03': 1.0258,
    '2022-08-03': 1.0125,
    '2022-07-03': 1.0042,
    '2022-04-03': 1.0014,
    '2022-03-03': 1.0147,
    '2022-02-03': 1.0237,
    '2022-01-03': 1.0218,
    '2022-28-02': 1.0283,
    '2022-25-02': 1.0422,
    '2022-24-02': 1.0362,
    '2022-23-02': 1.0383,
    '2022-22-02': 1.0435,
    '2022-21-02': 1.0355,
    '2022-18-02': 1.0432,
    '2022-17-02': 1.0452,
    '2022-16-02': 1.0493,
    '2022-15-02': 1.0509,
    '2022-14-02': 1.045,
    '2022-11-02': 1.0505,
    '2022-10-02': 1.0572,
    '2022-09-02': 1.0557,
    '2022-08-02': 1.0555,
    '2022-07-02': 1.0572,
    '2022-04-02': 1.0592,
    '2022-03-02': 1.052,
    '2022-02-02': 1.038,
    '2022-01-02': 1.0383,
    '2022-31-01': 1.0412,
    '2022-28-01': 1.0371,
    '2022-27-01': 1.0369,
    '2022-26-01': 1.0382,
    '2022-25-01': 1.0374,
    '2022-24-01': 1.0345,
    '2022-21-01': 1.0333,
    '2022-20-01': 1.0364,
    '2022-19-01': 1.0383,
    '2022-18-01': 1.0388,
    '2022-17-01': 1.0424,
    '2022-14-01': 1.0431,
    '2022-13-01': 1.0434,
    '2022-12-01': 1.0459,
    '2022-11-01': 1.0493,
    '2022-10-01': 1.0498,
    '2022-07-01': 1.0437,
    '2022-06-01': 1.04,
    '2022-05-01': 1.0372,
    '2022-04-01': 1.0334,
    '2022-03-01': 1.038,
    '2021-31-12': 1.037,
    '2021-30-12': 1.0339,
    '2021-29-12': 1.0378,
    '2021-28-12': 1.0375,
    '2021-27-12': 1.039,
    '2021-24-12': 1.0404,
    '2021-23-12': 1.0403,
    '2021-22-12': 1.0416,
    '2021-21-12': 1.0421,
    '2021-20-12': 1.0384,
    '2021-17-12': 1.0381,
    '2021-16-12': 1.0412,
    '2021-15-12': 1.0436,
    '2021-14-12': 1.04,
    '2021-13-12': 1.0409,
    '2021-10-12': 1.0416,
    '2021-09-12': 1.0425,
    '2021-08-12': 1.0438,
    '2021-07-12': 1.0422,
    '2021-06-12': 1.0445,
    '2021-03-12': 1.0383,
    '2021-02-12': 1.0397,
    '2021-01-12': 1.0418,
    '2021-30-11': 1.0413,
    '2021-29-11': 1.042,
    '2021-26-11': 1.0456,
    '2021-25-11': 1.0488,
    '2021-24-11': 1.0463,
    '2021-23-11': 1.0491,
    '2021-22-11': 1.0481,
    '2021-19-11': 1.0476,
    '2021-18-11': 1.0528,
    '2021-17-11': 1.0506,
    '2021-16-11': 1.0524,
    '2021-15-11': 1.0514,
    '2021-12-11': 1.0549,
    '2021-11-11': 1.0542,
    '2021-10-11': 1.0531,
    '2021-09-11': 1.0561,
    '2021-08-11': 1.0578,
    '2021-05-11': 1.0549,
    '2021-04-11': 1.0541,
    '2021-03-11': 1.0584,
    '2021-02-11': 1.0586,
    '2021-01-11': 1.0547,
    '2021-29-10': 1.0585,
    '2021-28-10': 1.0648,
    '2021-27-10': 1.0652,
    '2021-26-10': 1.0669,
    '2021-25-10': 1.0675,
    '2021-22-10': 1.0666,
    '2021-21-10': 1.067,
    '2021-20-10': 1.0703,
    '2021-19-10': 1.0734,
    '2021-18-10': 1.0723,
    '2021-15-10': 1.07,
    '2021-14-10': 1.0705,
    '2021-13-10': 1.0713,
    '2021-12-10': 1.0727,
    '2021-11-10': 1.0714,
    '2021-08-10': 1.0724,
    '2021-07-10': 1.0729,
    '2021-06-10': 1.0715,
    '2021-05-10': 1.0758,
    '2021-04-10': 1.0745,
    '2021-01-10': 1.0793,
    '2021-30-09': 1.0788,
    '2021-29-09': 1.0839,
    '2021-28-09': 1.0854,
    '2021-27-09': 1.0823,
    '2021-24-09': 1.0832,
    '2021-23-09': 1.0844,
    '2021-22-09': 1.0822,
    '2021-21-09': 1.0824,
    '2021-20-09': 1.0876,
    '2021-17-09': 1.0931,
    '2021-16-09': 1.0911,
    '2021-15-09': 1.0865,
    '2021-14-09': 1.086,
    '2021-13-09': 1.0888,
    '2021-10-09': 1.0841,
    '2021-09-09': 1.0841,
    '2021-08-09': 1.0892,
    '2021-07-09': 1.0885,
    '2021-06-09': 1.0857,
    '2021-03-09': 1.0854,
    '2021-02-09': 1.0853,
    '2021-01-09': 1.0832,
    '2021-31-08': 1.0803,
    '2021-30-08': 1.0814,
    '2021-27-08': 1.0745,
    '2021-26-08': 1.0782,
    '2021-25-08': 1.0753,
    '2021-24-08': 1.0721,
    '2021-23-08': 1.0712,
    '2021-20-08': 1.0726,
    '2021-19-08': 1.0725,
    '2021-18-08': 1.0736,
    '2021-17-08': 1.0707,
    '2021-16-08': 1.0741,
    '2021-13-08': 1.0793,
    '2021-12-08': 1.0828,
    '2021-11-08': 1.0819,
    '2021-10-08': 1.0811,
    '2021-09-08': 1.0804,
    '2021-06-08': 1.0753,
    '2021-05-08': 1.0736,
    '2021-04-08': 1.0731,
    '2021-03-08': 1.0717,
    '2021-02-08': 1.0744,
    '2021-30-07': 1.0747,
    '2021-29-07': 1.0771,
    '2021-28-07': 1.0775,
    '2021-27-07': 1.0802,
    '2021-26-07': 1.0807,
    '2021-23-07': 1.0818,
    '2021-22-07': 1.0814,
    '2021-21-07': 1.0819,
    '2021-20-07': 1.0857,
    '2021-19-07': 1.0829,
    '2021-16-07': 1.0851,
    '2021-15-07': 1.0839,
    '2021-14-07': 1.0828,
    '2021-13-07': 1.0813,
    '2021-12-07': 1.085,
    '2021-09-07': 1.085,
    '2021-08-07': 1.0841,
    '2021-07-07': 1.0908,
    '2021-06-07': 1.0925,
    '2021-05-07': 1.0935,
    '2021-02-07': 1.0921,
    '2021-01-07': 1.0961,
    '2021-30-06': 1.0965,
    '2021-29-06': 1.0951,
    '2021-28-06': 1.0962,
    '2021-25-06': 1.0949,
    '2021-24-06': 1.0946,
    '2021-23-06': 1.0955,
    '2021-22-06': 1.0957,
    '2021-21-06': 1.0933,
    '2021-18-06': 1.094,
    '2021-17-06': 1.0921,
    '2021-16-06': 1.0897,
    '2021-15-06': 1.0886,
    '2021-14-06': 1.0903,
    '2021-11-06': 1.087,
    '2021-10-06': 1.0883,
    '2021-09-06': 1.0907,
    '2021-08-06': 1.0913,
    '2021-07-06': 1.0938,
    '2021-04-06': 1.0939,
    '2021-03-06': 1.0953,
    '2021-02-06': 1.0959,
    '2021-01-06': 1.0951,
    '2021-31-05': 1.0987,
    '2021-28-05': 1.0968,
    '2021-27-05': 1.0932,
    '2021-26-05': 1.0945,
    '2021-25-05': 1.0967,
    '2021-24-05': 1.0957,
    '2021-21-05': 1.0932,
    '2021-20-05': 1.0968,
    '2021-19-05': 1.1001,
    '2021-18-05': 1.0969,
    '2021-17-05': 1.0975,
    '2021-14-05': 1.0939,
    '2021-13-05': 1.0941,
    '2021-12-05': 1.0974,
    '2021-11-05': 1.0974,
    '2021-10-05': 1.0929,
    '2021-07-05': 1.0959,
    '2021-06-05': 1.0946,
    '2021-05-05': 1.0958,
    '2021-04-05': 1.0974,
    '2021-03-05': 1.0986,
    '2021-30-04': 1.0976,
    '2021-29-04': 1.1007,
    '2021-28-04': 1.1025,
    '2021-27-04': 1.1042,
    '2021-26-04': 1.1041,
    '2021-23-04': 1.1051,
    '2021-22-04': 1.1013,
    '2021-21-04': 1.1034,
    '2021-20-04': 1.102,
    '2021-19-04': 1.101,
    '2021-16-04': 1.1024,
    '2021-15-04': 1.1039,
    '2021-14-04': 1.105,
    '2021-13-04': 1.1001,
    '2021-12-04': 1.0985,
    '2021-09-04': 1.1006,
    '2021-08-04': 1.1015,
    '2021-07-04': 1.1032,
    '2021-06-04': 1.1053,
    '2021-05-04': 1.106,
    '2021-02-04': 1.1081,
    '2021-01-04': 1.1092,
    '2021-31-03': 1.1064,
    '2021-30-03': 1.1035,
    '2021-29-03': 1.1045,
    '2021-26-03': 1.1072,
    '2021-25-03': 1.1058,
    '2021-24-03': 1.105,
    '2021-23-03': 1.1065,
    '2021-22-03': 1.1018,
    '2021-19-03': 1.106,
    '2021-18-03': 1.1044,
    '2021-17-03': 1.1049,
    '2021-16-03': 1.1002,
    '2021-15-03': 1.106,
    '2021-12-03': 1.1112,
    '2021-11-03': 1.1076,
    '2021-10-03': 1.1085,
    '2021-09-03': 1.1035,
    '2021-08-03': 1.1091,
    '2021-05-03': 1.1094,
    '2021-04-03': 1.111,
    '2021-03-03': 1.1093,
    '2021-02-03': 1.1058,
    '2021-01-03': 1.1021,
    '2021-26-02': 1.0966,
    '2021-25-02': 1.1011,
    '2021-24-02': 1.1022,
    '2021-23-02': 1.0995,
    '2021-22-02': 1.089,
    '2021-19-02': 1.0859,
    '2021-18-02': 1.0827,
    '2021-17-02': 1.0816,
    '2021-16-02': 1.0799,
    '2021-15-02': 1.0795,
    '2021-12-02': 1.0802,
    '2021-11-02': 1.0791,
    '2021-10-02': 1.0783,
    '2021-09-02': 1.081,
    '2021-08-02': 1.0826,
    '2021-05-02': 1.0823,
    '2021-04-02': 1.0817,
    '2021-03-02': 1.0816,
    '2021-02-02': 1.0804,
    '2021-01-02': 1.0815,
    '2021-29-01': 1.0805,
    '2021-28-01': 1.0772,
    '2021-27-01': 1.0762,
    '2021-26-01': 1.0779,
    '2021-25-01': 1.078,
    '2021-22-01': 1.077,
    '2021-21-01': 1.0765,
    '2021-20-01': 1.0767,
    '2021-19-01': 1.0773,
    '2021-18-01': 1.0755,
    '2021-15-01': 1.0758,
    '2021-14-01': 1.0795,
    '2021-13-01': 1.0791,
    '2021-12-01': 1.0816,
    '2021-11-01': 1.0814,
    '2021-08-01': 1.0818,
    '2021-07-01': 1.086,
    '2021-06-01': 1.0825,
    '2021-05-01': 1.0798,
    '2021-04-01': 1.0794,
    '2021-01-01': 1.0742,
    '2020-31-12': 1.081,
    '2020-30-12': 1.0832,
    '2020-29-12': 1.083,
    '2020-28-12': 1.086,
    '2020-25-12': 1.0848,
    '2020-24-12': 1.0851,
    '2020-23-12': 1.0818,
    '2020-22-12': 1.0818,
    '2020-21-12': 1.0839,
    '2020-18-12': 1.0824,
    '2020-17-12': 1.0847,
    '2020-16-12': 1.08,
    '2020-15-12': 1.0761,
    '2020-14-12': 1.0762,
    '2020-11-12': 1.077,
    '2020-10-12': 1.075,
    '2020-09-12': 1.0742,
    '2020-08-12': 1.0758,
    '2020-07-12': 1.078,
    '2020-04-12': 1.0812,
    '2020-03-12': 1.0817,
    '2020-02-12': 1.0834,
    '2020-01-12': 1.0859,
    '2020-30-11': 1.0843,
    '2020-27-11': 1.0815,
    '2020-26-11': 1.0793,
    '2020-25-11': 1.0817,
    '2020-24-11': 1.0833,
    '2020-23-11': 1.0804,
    '2020-20-11': 1.0797,
    '2020-19-11': 1.0815,
    '2020-18-11': 1.0796,
    '2020-17-11': 1.0807,
    '2020-16-11': 1.0818,
    '2020-13-11': 1.0798,
    '2020-12-11': 1.0798,
    '2020-11-11': 1.0803,
    '2020-10-11': 1.0813,
    '2020-09-11': 1.0787,
    '2020-06-11': 1.0687,
    '2020-05-11': 1.0688,
    '2020-04-11': 1.0696,
    '2020-03-11': 1.0677,
    '2020-02-11': 1.0696,
    '2020-30-10': 1.0677,
    '2020-29-10': 1.0684,
    '2020-28-10': 1.0693,
    '2020-27-10': 1.0716,
    '2020-26-10': 1.0714,
    '2020-23-10': 1.0723,
    '2020-22-10': 1.0716,
    '2020-21-10': 1.0735,
    '2020-20-10': 1.072,
    '2020-19-10': 1.0709,
    '2020-16-10': 1.0717,
    '2020-15-10': 1.071,
    '2020-14-10': 1.0733,
    '2020-13-10': 1.0745,
    '2020-12-10': 1.0739,
    '2020-09-10': 1.0761,
    '2020-08-10': 1.0779,
    '2020-07-10': 1.0786,
    '2020-06-10': 1.0766,
    '2020-05-10': 1.0783,
    '2020-02-10': 1.0787,
    '2020-01-10': 1.0787,
    '2020-30-09': 1.079,
    '2020-29-09': 1.0793,
    '2020-28-09': 1.0782,
    '2020-25-09': 1.0797,
    '2020-24-09': 1.0815,
    '2020-23-09': 1.0771,
    '2020-22-09': 1.0765,
    '2020-21-09': 1.076,
    '2020-18-09': 1.0791,
    '2020-17-09': 1.0761,
    '2020-16-09': 1.0741,
    '2020-15-09': 1.0755,
    '2020-14-09': 1.0775,
    '2020-11-09': 1.0762,
    '2020-10-09': 1.0755,
    '2020-09-09': 1.0767,
    '2020-08-09': 1.0805,
    '2020-07-09': 1.0823,
    '2020-04-09': 1.081,
    '2020-03-09': 1.0774,
    '2020-02-09': 1.0792,
    '2020-01-09': 1.083,
    '2020-31-08': 1.0784,
    '2020-28-08': 1.0758,
    '2020-27-08': 1.0743,
    '2020-26-08': 1.0742,
    '2020-25-08': 1.0738,
    '2020-24-08': 1.0746,
    '2020-21-08': 1.0751,
    '2020-20-08': 1.0763,
    '2020-19-08': 1.083,
    '2020-18-08': 1.0779,
    '2020-17-08': 1.0758,
    '2020-14-08': 1.0763,
    '2020-13-08': 1.0744,
    '2020-12-08': 1.0743,
    '2020-11-08': 1.0761,
    '2020-10-08': 1.0745,
    '2020-07-08': 1.0752,
    '2020-06-08': 1.0803,
    '2020-05-08': 1.0773,
    '2020-04-08': 1.0774,
    '2020-03-08': 1.0793,
    '2020-31-07': 1.0749,
    '2020-30-07': 1.0764,
    '2020-29-07': 1.0757,
    '2020-28-07': 1.0752,
    '2020-27-07': 1.0807,
    '2020-24-07': 1.0726,
    '2020-23-07': 1.0728,
    '2020-22-07': 1.0752,
    '2020-21-07': 1.0753,
    '2020-20-07': 1.0742,
    '2020-17-07': 1.0722,
    '2020-16-07': 1.076,
    '2020-15-07': 1.0772,
    '2020-14-07': 1.0707,
    '2020-13-07': 1.0675,
    '2020-10-07': 1.0629,
    '2020-09-07': 1.0606,
    '2020-08-07': 1.0628,
    '2020-07-07': 1.0617,
    '2020-06-07': 1.0651,
    '2020-03-07': 1.0637,
    '2020-02-07': 1.0621,
    '2020-01-07': 1.0639,
    '2020-30-06': 1.0637,
    '2020-29-06': 1.069,
    '2020-26-06': 1.0633,
    '2020-25-06': 1.0636,
    '2020-24-06': 1.0662,
    '2020-23-06': 1.0679,
    '2020-22-06': 1.0667,
    '2020-19-06': 1.0642,
    '2020-18-06': 1.0658,
    '2020-17-06': 1.0665,
    '2020-16-06': 1.0711,
    '2020-15-06': 1.0746,
    '2020-12-06': 1.0717,
    '2020-11-06': 1.0664,
    '2020-10-06': 1.0737,
    '2020-09-06': 1.0776,
    '2020-08-06': 1.0813,
    '2020-05-06': 1.086,
    '2020-04-06': 1.0829,
    '2020-03-06': 1.0796,
    '2020-02-06': 1.0746,
    '2020-01-06': 1.0696,
    '2020-29-05': 1.0667,
    '2020-28-05': 1.0677,
    '2020-27-05': 1.0654,
    '2020-26-05': 1.06,
    '2020-25-05': 1.0594,
    '2020-22-05': 1.0582,
    '2020-21-05': 1.0624,
    '2020-20-05': 1.0592,
    '2020-19-05': 1.0606,
    '2020-18-05': 1.0593,
    '2020-15-05': 1.0506,
    '2020-14-05': 1.0512,
    '2020-13-05': 1.0512,
    '2020-12-05': 1.0513,
    '2020-11-05': 1.0513,
    '2020-08-05': 1.0521,
    '2020-07-05': 1.0537,
    '2020-06-05': 1.0522,
    '2020-05-05': 1.0537,
    '2020-04-05': 1.0523,
    '2020-01-05': 1.0553,
    '2020-30-04': 1.0574,
    '2020-29-04': 1.0585,
    '2020-28-04': 1.0548,
    '2020-27-04': 1.0559,
    '2020-24-04': 1.0527,
    '2020-23-04': 1.0515,
    '2020-22-04': 1.0511,
    '2020-21-04': 1.0525,
    '2020-20-04': 1.0511,
    '2020-17-04': 1.0512,
    '2020-16-04': 1.0513,
    '2020-15-04': 1.0519,
    '2020-14-04': 1.0541,
    '2020-13-04': 1.0555,
    '2020-10-04': 1.0563,
    '2020-09-04': 1.0552,
    '2020-08-04': 1.0549,
    '2020-07-04': 1.0555,
    '2020-06-04': 1.056,
    '2020-03-04': 1.0567,
    '2020-02-04': 1.0569,
    '2020-01-04': 1.0583,
    '2020-31-03': 1.0597,
    '2020-30-03': 1.0587,
    '2020-27-03': 1.0596,
    '2020-26-03': 1.0624,
    '2020-25-03': 1.0626,
    '2020-24-03': 1.0587,
    '2020-23-03': 1.0555,
    '2020-20-03': 1.055,
    '2020-19-03': 1.0539,
    '2020-18-03': 1.0565,
    '2020-17-03': 1.0566,
    '2020-16-03': 1.0587,
    '2020-13-03': 1.0545,
    '2020-12-03': 1.0553,
    '2020-11-03': 1.0576,
    '2020-10-03': 1.0599,
    '2020-09-03': 1.0588,
    '2020-06-03': 1.0576,
    '2020-05-03': 1.0623,
    '2020-04-03': 1.0652,
    '2020-03-03': 1.0679,
    '2020-02-03': 1.0677,
    '2020-28-02': 1.0641,
    '2020-27-02': 1.0642,
    '2020-26-02': 1.0626,
    '2020-25-02': 1.0618,
    '2020-24-02': 1.0621,
    '2020-21-02': 1.0604,
    '2020-20-02': 1.0608,
    '2020-19-02': 1.0628,
    '2020-18-02': 1.0609,
    '2020-17-02': 1.0625,
    '2020-14-02': 1.0635,
    '2020-13-02': 1.0615,
    '2020-12-02': 1.0633,
    '2020-11-02': 1.0649,
    '2020-10-02': 1.0659,
    '2020-07-02': 1.0699,
    '2020-06-02': 1.0699,
    '2020-05-02': 1.0702,
    '2020-04-02': 1.0702,
    '2020-03-02': 1.0679,
    '2020-31-01': 1.0683,
    '2020-30-01': 1.0691,
    '2020-29-01': 1.0712,
    '2020-28-01': 1.072,
    '2020-27-01': 1.0681,
    '2020-24-01': 1.0703,
    '2020-23-01': 1.0706,
    '2020-22-01': 1.0733,
    '2020-21-01': 1.0732,
    '2020-20-01': 1.0738,
    '2020-17-01': 1.0733,
    '2020-16-01': 1.0739,
    '2020-15-01': 1.0745,
    '2020-14-01': 1.0763,
    '2020-13-01': 1.0807,
    '2020-10-01': 1.0812,
    '2020-09-01': 1.0806,
    '2020-08-01': 1.0812,
    '2020-07-01': 1.0819,
    '2020-06-01': 1.0838,
    '2020-03-01': 1.0851,
    '2020-02-01': 1.0848,
    '2020-01-01': 1.0848,
}
